import type { NextPage, NextPageContext } from 'next/types';

import type { InsightsResultsProps } from 'Components/Insights/ResultsPage/ResultsPage';
import { ResultsPage } from 'Components/Insights/ResultsPage/ResultsPage';
import PageComposer from 'Components/PageComposer/PageComposer';
import type { Make } from 'Types/make';
import type { Model } from 'Types/model';
import { auth } from 'Utilities/getInitialPropsMiddlewares/auth/auth';
import { blockPendingCheck } from 'Utilities/getInitialPropsMiddlewares/blockedPendingCheck/blockPendingCheck';
import type { GetInitialPropsMiddlewareContext } from 'Utilities/getInitialPropsMiddlewares/getInitialPropsMiddlewares.types';
import { createMiddlewarePipeline } from 'Utilities/helpers/middlewarePipeline/middlewarePipeline';

const InsightsResults: NextPage<InsightsResultsProps> = (props) => {
	const { make, makes, model, models } = props;

	return (
		<PageComposer>
			<ResultsPage make={make} makes={makes} model={model} models={models} />
		</PageComposer>
	);
};

type InsightsResultsPropsWithInitialProps = NextPageContext & {
	makes: Make[];
	models: Model[];
};

const insightsResultsGetInitialProps = async (
	context: InsightsResultsPropsWithInitialProps,
): Promise<InsightsResultsProps> => {
	type MiddlewarePipelineContext = GetInitialPropsMiddlewareContext<typeof context, InsightsResultsProps>;

	const middlewarePipeline = createMiddlewarePipeline<MiddlewarePipelineContext>(
		auth,
		blockPendingCheck,
		async (pipelineContext) => {
			const { nextContext } = pipelineContext;

			const {
				makes,
				models,
				query: { make, model },
			} = nextContext;

			pipelineContext.returnValue = {
				make,
				makes,
				model,
				models,
			};
		},
	);

	const getInitialPropsMiddlewareContext: MiddlewarePipelineContext = {
		nextContext: context,
		returnValue: {
			makes: [],
			models: [],
		},
	};

	await middlewarePipeline.run(getInitialPropsMiddlewareContext);

	return getInitialPropsMiddlewareContext.returnValue;
};

InsightsResults.getInitialProps = insightsResultsGetInitialProps;

export default InsightsResults;
